
import {Vue, Component, Prop} from 'vue-property-decorator';
import GiftIcon from '@/components/Icons/GiftIcon.vue';
@Component({
    components:{
        GiftIcon
    }
})
export default class GiftInfo extends Vue {
  @Prop({type: String, default: ''}) public readonly title!: string;
  @Prop({type: String, default: ''}) public readonly link!: string;
}
